/**
 * smart-home-showcase: one Swiper markup for PC + mobile. PC: Swiper horizontal. Mobile: each slide = one photo group; View more adds .is-visible to the next slide. Lightbox on zoom click.
 */
(function () {
  class SmartHomeShowcase extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;

      const slideHost = this.querySelector('.smart-home-showcase__desktop');
      const viewBtn = this.querySelector('.smart-home-showcase__view-more');
      const dialog = this.querySelector('.smart-home-showcase__lightbox');
      const dialogImg = dialog ? dialog.querySelector('.smart-home-showcase__lightbox-img') : null;
      const closeBtn = dialog ? dialog.querySelector('.smart-home-showcase__lightbox-close') : null;

      const mobileSlides = slideHost ? slideHost.querySelectorAll('.smart-home-showcase__swiper-slide') : [];
      const viewMoreWrap = viewBtn ? viewBtn.closest('.smart-home-showcase__view-more-wrap') : null;

      this._mobileVisible = 1;
      const viewMoreLabelEl = viewBtn ? viewBtn.querySelector('.smart-home-showcase__view-more-label') : null;
      if (viewBtn && slideHost && mobileSlides.length > 1) {
        const moreLabel = this.dataset.viewMoreLabel || 'View more';
        if (viewMoreLabelEl) {
          viewMoreLabelEl.textContent = moreLabel;
        } else {
          viewBtn.textContent = moreLabel;
        }
        viewBtn.hidden = false;
        if (viewMoreWrap) viewMoreWrap.hidden = false;
        const self = this;
        viewBtn.addEventListener('click', function () {
          if (self._mobileVisible >= mobileSlides.length) return;
          self._mobileVisible += 1;
          mobileSlides.forEach(function (slide, idx) {
            if (idx < self._mobileVisible) {
              slide.classList.add('is-visible');
            }
          });
          if (self._mobileVisible >= mobileSlides.length) {
            if (viewMoreWrap) {
              viewMoreWrap.hidden = true;
            } else {
              viewBtn.hidden = true;
            }
          }
        });
      } else if (viewBtn) {
        viewBtn.hidden = true;
        if (viewMoreWrap) viewMoreWrap.hidden = true;
      }

      function resetLightboxImg() {
        if (!dialogImg) return;
        dialogImg.onload = null;
        dialogImg.onerror = null;
        dialogImg.removeAttribute('src');
        dialogImg.alt = '';
        dialogImg.classList.remove('is-loading');
      }

      this.addEventListener('click', function (e) {
        const zoom = e.target.closest('.smart-home-showcase__zoom');
        if (!zoom || !dialog || !dialogImg) return;
        e.preventDefault();
        const inner = zoom.closest('.smart-home-showcase__cell-inner');
        const img = inner ? inner.querySelector('img') : null;
        if (!img) return;
        const src = img.getAttribute('data-full-src') || img.currentSrc || img.src;
        const alt = img.getAttribute('data-full-alt') || img.alt || '';
        if (!src) return;

        const scrollY = window.scrollY;
        dialogImg.onload = null;
        dialogImg.onerror = null;
        dialogImg.removeAttribute('src');
        dialogImg.alt = alt;
        dialogImg.classList.add('is-loading');

        function reveal() {
          dialogImg.onload = null;
          dialogImg.onerror = null;
          var done = function () {
            dialogImg.classList.remove('is-loading');
          };
          if (dialogImg.decode) {
            dialogImg.decode().then(done).catch(done);
          } else {
            done();
          }
        }

        dialogImg.onload = reveal;
        dialogImg.onerror = reveal;

        dialog.showModal();
        requestAnimationFrame(function () {
          window.scrollTo(0, scrollY);
        });

        dialogImg.src = src;
        if (dialogImg.complete && dialogImg.naturalWidth > 0) {
          reveal();
        }
      });

      if (closeBtn && dialog) {
        closeBtn.addEventListener('click', function () {
          dialog.close();
        });
      }
      if (dialog) {
        dialog.addEventListener('click', function (e) {
          if (e.target === dialog) dialog.close();
        });
        dialog.addEventListener('close', resetLightboxImg);
      }

      this._initSwiperWhenReady();
      this._ready = true;
    }

    _initSwiperWhenReady() {
      const root = this;
      const run = function () {
        if (typeof Swiper === 'undefined') {
          requestAnimationFrame(run);
          return;
        }
        const mq = window.matchMedia('(min-width: 768px)');
        const swiperEl = root.querySelector('.smart-home-showcase__swiper-pc');
        if (!swiperEl) return;

        const bind = function () {
          if (mq.matches) {
            if (root._swiper) return;
            root._swiper = new Swiper(swiperEl, {
              slidesPerView: 'auto',
              watchOverflow: true,
              speed: 450,
              observer: true,
              observeParents: true
            });
          } else if (root._swiper) {
            root._swiper.destroy(true, true);
            root._swiper = null;
          }
        };

        root._mq = mq;
        root._mqBind = bind;
        mq.addEventListener('change', bind);
        bind();
      };
      run();
    }

    disconnectedCallback() {
      if (this._mq && this._mqBind) {
        this._mq.removeEventListener('change', this._mqBind);
      }
      if (this._swiper) {
        this._swiper.destroy(true, true);
        this._swiper = null;
      }
    }
  }

  if (!customElements.get('smart-home-showcase')) {
    customElements.define('smart-home-showcase', SmartHomeShowcase);
  }
})();
